import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const CTASection = ({ title = "Ready to build your system?" }) => (
  <section className="py-24 md:py-40 bg-[#2E1B16] text-[#FAF7F2]" data-testid="cta-section">
    <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
      <Reveal>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02]">
          {title.split("system")[0]}
          <span className="font-accent text-[#38BDF8]">system?</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link to="/#contact" className="group inline-flex items-center gap-2 rounded-full bg-[#38BDF8] text-[#2E1B16] font-semibold px-8 py-4 hover:bg-[#FAF7F2] transition-colors" data-testid="cta-enquiry">
            Send an enquiry
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </Link>
          <Link to="/#book" className="inline-flex items-center rounded-full border border-white/25 px-8 py-4 font-semibold hover:border-white/60 transition-colors" data-testid="cta-book">
            Book a strategy call
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTASection;
